import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { MenuService } from '../../services/menu.service';
import { menus } from '../../consts/menu';
import { Menu } from '../../models/menu';
import { UserService } from '../../services/user.service';
import { MsalService } from '@azure/msal-angular';
import { TranslationService } from '../../services/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '../../services/theme.service';
import { languages } from '../../consts/languages';
import { AreaContextService } from '../../services/area-context.service';
import { AuthService } from '../../services/auth.service';
import { BannerService } from '../../services/banner.service';

@Component({
  selector: 'app-side-menu',
  imports: [TegelModule, TranslateModule, AsyncPipe, RouterLink],
  templateUrl: './side-menu.html',
  styleUrl: './side-menu.scss',
})
export class SideMenu {
  private readonly router = inject(Router);
  private readonly menu = inject(MenuService);
  private readonly user = inject(UserService);
  private readonly msal = inject(MsalService);
  private readonly i18n = inject(TranslationService);
  private readonly areaContext = inject(AreaContextService);
  private readonly auth = inject(AuthService);
  private readonly banners = inject(BannerService);
  readonly theme = inject(ThemeService);

  menus = menus;
  languages = languages;
  areas = this.user.areas;

  isMenuOpened = this.menu.isOpen;
  selectedMenu = this.menu.selected;

  selectedArea = this.areaContext.selectedArea;
  currentLanguage$ = this.i18n.currentLanguage$;

  username = this.user.username;
  useremail = this.user.useremail;
  userphoto = this.user.userphoto;

  handleMenuLinkClick(event: MouseEvent, path: string): void {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }

    this.menu.setSignal(false);
    this.menu.selectedMenu(path);
  }

  mobileMenuAction(action: boolean) {
    this.menu.setSignal(action);
  }

  changeArea(areaId: string) {
    this.areaContext.select(areaId);
  }

  changeTranslation(value: string) {
    this.i18n.setLanguage(value as any);
  }

  hasAccess(roles: string[] | undefined): boolean {
    return this.auth.checkMenuAccess(roles);
  }

  hasVisibleChildren(menu: Menu): boolean {
    return !!menu.subMenu?.some((item) => this.canShowItem(item));
  }

  canShowItem(menu: Menu): boolean {
    return !menu.hidden && this.hasAccess(menu.permissions) && this.isAvailableRoute(menu.path);
  }

  private isAvailableRoute(path?: string): boolean {
    if (!path) {
      return true;
    }

    const normalizedPath = path === '/' ? '' : path.replace(/^\/+/, '');
    return this.router.config.some((route) => route.path === normalizedPath);
  }

  toggleTheme(): void {
    this.theme.toggle();
  }

  logout() {
    this.banners.clearDismissed();
    this.msal.logoutRedirect();
  }
}
